import { Link } from "react-router-dom";

export default function PoliticasPage() {
  return (
    <main className="min-h-screen" style={{ background: "#F9F5EE" }}>
      {/* Header */}
      <div
        className="relative py-20 px-6 text-center overflow-hidden"
        style={{ background: "linear-gradient(135deg, #001A3D 0%, #002D62 60%, #001A3D 100%)" }}
      >
        {/* Gold top line */}
        <div
          className="absolute top-0 left-0 w-full h-[3px]"
          style={{ background: "linear-gradient(90deg, transparent, #D4AF37, #F0D060, #D4AF37, transparent)" }}
        />
        {/* Gold bottom line */}
        <div
          className="absolute bottom-0 left-0 w-full h-[2px]"
          style={{ background: "linear-gradient(90deg, transparent, #D4AF37, transparent)" }}
        />

        <div className="max-w-3xl mx-auto">
          <div className="flex items-center justify-center gap-4 mb-5">
            <div className="h-[1px] w-10" style={{ background: "#D4AF37" }} />
            <p className="text-xs font-semibold tracking-widest uppercase" style={{ color: "#D4AF37", letterSpacing: "4px" }}>
              Información Legal
            </p>
            <div className="h-[1px] w-10" style={{ background: "#D4AF37" }} />
          </div>

          <h1
            className="font-bold mb-4"
            style={{
              fontFamily: "'Playfair Display', serif",
              fontSize: "clamp(2rem, 4vw, 3rem)",
              color: "#FFFFFF",
              lineHeight: 1.15,
            }}
          >
            Políticas y{" "}
            <span style={{ color: "#D4AF37" }}>Privacidad</span>
          </h1>

          <p className="text-sm" style={{ color: "rgba(255,255,255,0.55)", fontFamily: "'Inter', sans-serif" }}>
            El Secuestro de Lucho &mdash; Carlos Alberto Díaz Martínez
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-3xl mx-auto px-6 py-16">

        {/* Back link */}
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm font-medium mb-12 transition-all duration-200 cursor-pointer whitespace-nowrap"
          style={{ color: "#8B6914" }}
          onMouseEnter={e => (e.currentTarget as HTMLAnchorElement).style.color = "#D4AF37"}
          onMouseLeave={e => (e.currentTarget as HTMLAnchorElement).style.color = "#8B6914"}
        >
          <i className="ri-arrow-left-line" />
          Volver al inicio
        </Link>

        {/* Card 1 — ISBN */}
        <div
          className="rounded-2xl p-8 mb-6"
          style={{
            background: "#FFFFFF",
            border: "1px solid rgba(212,175,55,0.25)",
          }}
        >
          <div className="flex items-start gap-5">
            <div
              className="w-12 h-12 flex items-center justify-center rounded-xl flex-shrink-0"
              style={{ background: "linear-gradient(135deg, #D4AF37, #F0D060)" }}
            >
              <i className="ri-barcode-line text-xl" style={{ color: "#001A3D" }} />
            </div>
            <div>
              <p
                className="text-xs font-bold tracking-widest uppercase mb-1"
                style={{ color: "#D4AF37", letterSpacing: "3px", fontFamily: "'Inter', sans-serif" }}
              >
                Ficha de Registro
              </p>
              <h2
                className="font-bold mb-3"
                style={{ fontFamily: "'Playfair Display', serif", fontSize: "1.35rem", color: "#001A3D" }}
              >
                ISBN — International Standard Book Number
              </h2>
              <div
                className="inline-flex items-center gap-3 rounded-xl px-5 py-3"
                style={{ background: "#F9F5EE", border: "1px solid rgba(212,175,55,0.3)" }}
              >
                <i className="ri-book-2-line" style={{ color: "#D4AF37" }} />
                <span
                  className="font-bold tracking-wider"
                  style={{ fontFamily: "'Inter', sans-serif", fontSize: "1.05rem", color: "#001A3D", letterSpacing: "1.5px" }}
                >
                  ISBN Obra Independiente: 978-980-18-8341-8
                </span>
              </div>
              <p
                className="mt-4 text-sm leading-relaxed"
                style={{ color: "#555", fontFamily: "'Inter', sans-serif" }}
              >
                El ISBN (International Standard Book Number) es el identificador numérico único asignado a esta obra literaria a nivel internacional, garantizando su registro y distribución oficial en el mercado editorial global.
              </p>
            </div>
          </div>
        </div>

        {/* Card 2 — Depósito Legal */}
        <div
          className="rounded-2xl p-8 mb-6"
          style={{
            background: "#FFFFFF",
            border: "1px solid rgba(212,175,55,0.25)",
          }}
        >
          <div className="flex items-start gap-5">
            <div
              className="w-12 h-12 flex items-center justify-center rounded-xl flex-shrink-0"
              style={{ background: "linear-gradient(135deg, #D4AF37, #F0D060)" }}
            >
              <i className="ri-government-line text-xl" style={{ color: "#001A3D" }} />
            </div>
            <div>
              <p
                className="text-xs font-bold tracking-widest uppercase mb-1"
                style={{ color: "#D4AF37", letterSpacing: "3px", fontFamily: "'Inter', sans-serif" }}
              >
                Registro Oficial
              </p>
              <h2
                className="font-bold mb-3"
                style={{ fontFamily: "'Playfair Display', serif", fontSize: "1.35rem", color: "#001A3D" }}
              >
                Número de Depósito Legal
              </h2>
              <div
                className="inline-flex items-center gap-3 rounded-xl px-5 py-3"
                style={{ background: "#F9F5EE", border: "1px solid rgba(212,175,55,0.3)" }}
              >
                <i className="ri-file-shield-2-line" style={{ color: "#D4AF37" }} />
                <span
                  className="font-bold tracking-wider"
                  style={{ fontFamily: "'Inter', sans-serif", fontSize: "1.05rem", color: "#001A3D", letterSpacing: "1.5px" }}
                >
                  ZU2026000095
                </span>
              </div>
              <p
                className="mt-4 text-sm leading-relaxed"
                style={{ color: "#555", fontFamily: "'Inter', sans-serif" }}
              >
                El Depósito Legal es el registro obligatorio ante las autoridades competentes que certifica la existencia y autoría de esta obra, protegiéndola legalmente dentro del territorio nacional.
              </p>
            </div>
          </div>
        </div>

        {/* Card 3 — Derechos de Autor */}
        <div
          className="rounded-2xl p-8 mb-10"
          style={{
            background: "linear-gradient(135deg, #001A3D 0%, #002D62 100%)",
            border: "1px solid rgba(212,175,55,0.3)",
          }}
        >
          <div className="flex items-start gap-5">
            <div
              className="w-12 h-12 flex items-center justify-center rounded-xl flex-shrink-0"
              style={{ background: "rgba(212,175,55,0.15)", border: "1px solid rgba(212,175,55,0.4)" }}
            >
              <i className="ri-copyright-line text-xl" style={{ color: "#D4AF37" }} />
            </div>
            <div>
              <p
                className="text-xs font-bold tracking-widest uppercase mb-1"
                style={{ color: "#D4AF37", letterSpacing: "3px", fontFamily: "'Inter', sans-serif" }}
              >
                Propiedad Intelectual
              </p>
              <h2
                className="font-bold mb-4"
                style={{ fontFamily: "'Playfair Display', serif", fontSize: "1.35rem", color: "#FFFFFF" }}
              >
                Derechos de Autor
              </h2>

              <div
                className="rounded-xl p-5 mb-4"
                style={{ background: "rgba(212,175,55,0.08)", border: "1px solid rgba(212,175,55,0.2)" }}
              >
                <p
                  className="text-sm leading-relaxed"
                  style={{ color: "rgba(255,255,255,0.85)", fontFamily: "'Inter', sans-serif" }}
                >
                  <strong style={{ color: "#D4AF37" }}>© 2026 Carlos Alberto Díaz Martínez.</strong>{" "}
                  Todos los derechos reservados. Queda prohibida la reproducción total o parcial de esta obra, su incorporación a un sistema informático, su transmisión en cualquier forma o por cualquier medio —electrónico, mecánico, fotocopia, grabación u otros— sin la autorización previa y por escrito del titular de los derechos de autor.
                </p>
              </div>

              <ul className="space-y-2">
                {[
                  "Reproducción o copia sin autorización escrita",
                  "Distribución comercial no autorizada",
                  "Adaptación, traducción o transformación de la obra",
                  "Uso del contenido con fines comerciales sin permiso",
                ].map((item, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <div className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-close-circle-line text-sm" style={{ color: "#D4AF37" }} />
                    </div>
                    <span className="text-sm" style={{ color: "rgba(255,255,255,0.65)", fontFamily: "'Inter', sans-serif" }}>
                      {item}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Footer note */}
        <div className="text-center">
          <div className="flex items-center justify-center gap-4 mb-4">
            <div className="h-[1px] w-16" style={{ background: "rgba(212,175,55,0.4)" }} />
            <i className="ri-star-fill text-xs" style={{ color: "#D4AF37" }} />
            <div className="h-[1px] w-16" style={{ background: "rgba(212,175,55,0.4)" }} />
          </div>
          <p
            className="text-xs"
            style={{ color: "#999", fontFamily: "'Inter', sans-serif", lineHeight: 1.8 }}
          >
            Para solicitudes de permisos, licencias o información adicional sobre los derechos de esta obra,<br />
            por favor comuníquese directamente con el autor.
          </p>
          <p
            className="text-xs mt-3 font-semibold"
            style={{ color: "#8B6914", fontFamily: "'Inter', sans-serif" }}
          >
            &copy; 2026 El Secuestro de Lucho &mdash; Todos los derechos reservados.
          </p>
        </div>

      </div>
    </main>
  );
}
